module.exports = __webpack_public_path__ + "school/img/ebooksCategory.0e418247.jpg";